import { render, staticRenderFns } from "./industrialinfo.vue?vue&type=template&id=0045d469&scoped=true"
import script from "./industrialinfo.vue?vue&type=script&lang=js"
export * from "./industrialinfo.vue?vue&type=script&lang=js"
import style0 from "./industrialinfo.vue?vue&type=style&index=0&id=0045d469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045d469",
  null
  
)

export default component.exports